// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@eisinc/Overrides/Components/AddToListModal";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import {
    color,
    modalButtonsActionStyles,
    sharedProductDescriptionStyles,
    styledScrollbar,
    xScreen,
} from "@eisinc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

addToListModalStyles.modal = {
    sizeVariant: "small",
};

addToListModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
    css: css`
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        padding-top: 16px;
        ${({ showProductsSelection }: any) =>
            showProductsSelection &&
            css`
                border-top: 1px solid ${color("common.border")};
            `}
    `,
};
addToListModalStyles.addButton = { ...modalButtonsActionStyles.submitButton };
addToListModalStyles.cancelButton = { ...modalButtonsActionStyles.cancelButton };

addToListModalStyles.productDataTableCell = {
    css: css`
        white-space: unset;
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

addToListModalStyles.productCheckboxDataTableCell = {
    css: css`
        vertical-align: top;
    `,
};

addToListModalStyles.productDataTableWrapper = {
    css: css`
        ${({ allowMultipleWishLists, selectedWishListId }: any) =>
            allowMultipleWishLists
                ? selectedWishListId === "new"
                    ? css`
                          max-height: calc(100vh - 474px);
                      `
                    : css`
                          max-height: calc(100vh - 410px);
                      `
                : css`
                      max-height: calc(100vh - 264px);
                  `}

        padding-right: 12px;
        ${styledScrollbar()}
    `,
};

addToListModalStyles.productImageAndInfoWrapper = {
    css: css`
        display: grid;
        grid-template-columns: 72px 1fr;
        gap: 12px;
        ${xScreen("lt", "sm")} {
            grid-template-columns: 72px 1fr;
        }
    `,
};

addToListModalStyles.productInfoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

addToListModalStyles.productDescriptionStyles = {
    ...sharedProductDescriptionStyles({
        lines: 2, lineHeight: 14, fontSize: 12,
        styles: {
            productDetailDescription: {
                css: css`
                    margin-bottom:8px;
                `,
            },
            productDetailLink: {
                css: css`
                    margin-bottom:8px;
                    &&& ${TypographyStyle} {
                        font-weight: ${fontConfig.weight.medium};
                        font-size: ${fontConfig.singleLinexSmall.size}px;
                        line-height: ${fontConfig.singleLinexSmall.lineHeight};
                    }
                `,
            },
        },
    }),
};

addToListModalStyles.productImage = {
    width: "72px",
    height: "72px",
    css: css`
        aspect-ratio: 1;
    `,
};

addToListModalStyles.descriptionText = {
    ...fontConfig.small,
};

addToListModalStyles.listsSelect = addToListModalStyles.newListInput = {
    cssOverrides: {
        formField: css`
            margin-top: 12px;
        `,
    },
};

addToListModalStyles.scheduleReminderCheckbox = {
    css: css`
        margin-top: 12px;
        width: 100%;
    `,
};

addToListModalStyles.selectAllProductsCheckbox = {
    css: css`
        ${({ allowMultipleWishLists }: any) =>
            allowMultipleWishLists &&
            css`
                margin-top: 16px;
                border-top: 1px solid ${color("common.border")};
                padding-top: 16px;
            `}
    `,
};

addToListModalStyles.productsSelectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 12px;
    `,
};

addToListModalStyles.innerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

addToListModalStyles.dataTableHeaderStyles = {
    css: css`
        &&& {
            border-left: 0;
            border-right: 0;
        }
    `,
};

addToListModalStyles.productBrandStyles = {
    wrapper: {
        css: css`
            margin-top: 2px;
        `,
    },
    nameLink: {
        typographyProps: {
            css: css`
                &&&& {
                    font-size: ${fontConfig.singleLinexSmall.size}px;
                    line-height: ${fontConfig.singleLinexSmall.lineHeight};
                    font-weight: ${fontConfig.weight.medium};
                }
            `,
        }
    },
};
addToListModalStyles.dataTableRow = {
    css: css`
        border-bottom: 1px solid ${color("common.ui3")};
        &:nth-child(2n) {
            background: ${color("common.ui1")};
        }
    `,
};